// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f9ab7e96","455":"ad29e609","977":"61e17efc"}[chunkId] + ".chunk.js";
};